import { render, staticRenderFns } from "./CultureListe.vue?vue&type=template&id=0b20a537"
import script from "./CultureListe.vue?vue&type=script&lang=js"
export * from "./CultureListe.vue?vue&type=script&lang=js"
import style0 from "./CultureListe.vue?vue&type=style&index=0&id=0b20a537&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports